// src/components/OneDriveCallback.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { onedriveIntegrationService } from './backend/oneDriveIntegrationService';
import { supabase } from './backend/supabase';

const OneDriveCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);

    useEffect(() => {
        const handleCallback = async () => {
        try {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            
            if (!code) {
            throw new Error('No authorization code received');
            }
    
            if (!state) {
            throw new Error('No state parameter received');
            }
            
            // Get the current user session to extract the user ID
            const { data } = await supabase.auth.getSession();
            const userId = data?.session?.user?.id;
            
            console.log('User ID for OneDrive auth:', userId);
            
            if (!userId) {
            throw new Error('No authenticated user found');
            }
    
            // Pass the userId to the exchange code function
            const result = await onedriveIntegrationService.exchangeCode(code, state, userId);
            console.log('Exchange result:', result);
    
            // Redirect back to integration hub
            navigate('/kiwi-ai', {
            state: { message: 'OneDrive integration connected successfully!' }
            });
        } catch (error) {
            console.error('Error handling OneDrive callback:', error);
            setError(error.message || 'Failed to complete OneDrive integration');
        } finally {
            setIsProcessing(false);
        }
        };
    
        handleCallback();
    }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md w-full shadow-sm">
          <div className="flex items-center gap-3 mb-3">
            <AlertCircle className="w-6 h-6 text-red-500" />
            <h2 className="text-lg font-semibold text-red-600">Connection Error</h2>
          </div>
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/settings/integrations')}
            className="w-full px-4 py-2 bg-red-100 hover:bg-red-200 text-red-600 rounded-lg transition-colors"
          >
            Back to Integrations
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-blue-600 mb-4 mx-auto" />
        <p className="text-gray-800">
          {isProcessing ? 'Connecting your OneDrive account...' : 'Redirecting...'}
        </p>
      </div>
    </div>
  );
};

export default OneDriveCallback;